<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title>
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          Add a Notification
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="6">
              <v-autocomplete
                v-model="form.user_id"
                :items="userItems"
                item-text="text"
                item-value="value"
                outlined
                label="Target User"
                prepend-inner-icon="mdi-account"
                :error-messages="errors.user_id"
                clearable
                hint="Leave empty to send to all users"
                persistent-hint
              ></v-autocomplete>
            </v-col>
            <v-col sm="6">
              <v-autocomplete
                v-model="form.type_id"
                :items="notificationTypes"
                item-text="text"
                item-value="value"
                outlined
                label="Notification Type *"
                prepend-inner-icon="mdi-tag"
                :error-messages="errors.type_id"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="form.message"
                outlined
                label="Message *"
                prepend-inner-icon="mdi-message-text"
                :error-messages="errors.message"
                rows="4"
                counter
                hint="Enter the notification message"
                persistent-hint
              ></v-textarea>
            </v-col>
            <v-col sm="6">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.status"
                inset
                :label="`Mark as Read: ${form.status ? 'YES' : 'NO'}`"
                hint="Set initial read status"
                persistent-hint
              ></v-switch>
            </v-col>
            <v-col sm="6">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
          </v-row>

          <v-divider class="mt-5 mb-5"></v-divider>
          <v-btn
            :loading="isLoading"
            :disabled="isLoading"
            rounded
            color="primary"
            dark
            @click="save"
          >
            Save Notification
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from "@/axios";

export default {
  name: "NotificationCreatePage",
  data() {
    return {
      form: {
        user_id: null,
        type_id: 1,
        message: "",
        status: false,
        is_active: true,
      },
      errors: {},
      isLoading: false,
      userItems: [],
      notificationTypes: [
        { text: "System", value: 1 },
        { text: "User", value: 2 },
        { text: "Order", value: 3 },
        { text: "Payment", value: 4 },
        { text: "Alert", value: 5 },
      ],
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      try {
        const response = await axios.get("/masters?context=notifications");
        if (response.data && response.data.users) {
          const users = response.data.users.data || response.data.users;
          this.userItems = users.map((user) => ({
            text: user.user_name || `${user.first_name} ${user.last_name}`,
            value: user.id,
          }));

          // Add "All Users" option
          this.userItems.unshift({
            text: "All Users",
            value: null,
          });
        }
      } catch (error) {
        console.error("Error loading masters:", error);
        if (error.response && error.response.status === 401) {
          this.$router.push("/login");
        }
      }
    },

    async save() {
      try {
        this.isLoading = true;
        this.errors = {};

        const response = await axios.post("/notifications", this.form);

        if (response.data.success) {
          this.$store.dispatch("errors/setSuccess", {
            message: "Notification created successfully",
          });
          this.$router.push("/notifications");
        } else {
          this.$store.dispatch("errors/setError", {
            message: response.data.message || "Failed to create notification",
          });
        }
      } catch (error) {
        console.error("Error creating notification:", error);

        if (error.response && error.response.status === 422) {
          this.errors = error.response.data.errors || {};
        } else if (error.response && error.response.status === 401) {
          this.$router.push("/login");
        } else if (error.response && error.response.status === 403) {
          this.$store.dispatch("errors/setError", {
            message: "You don't have permission to create notifications",
          });
        } else {
          this.$store.dispatch("errors/setError", {
            message: "Error creating notification",
          });
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>